module.exports = {"backendURL":"https://bkndnicaragua.miweb.cr:5004"}


//////////////////
// WEBPACK FOOTER
// ./src/data/config.json
// module id = 8
// module chunks = 168707334958949